import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { numberFloat2Decimals } from '../utils/utility-functions.utils';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'customPricing',
})
export class CustomPricingPipe implements PipeTransform {
    public transform(price: number, needCentsFormatting: boolean = false): string {
        if (price === 0) {
            return '0 €';
        }
        if (price === undefined || price === null) {
            return '';
        }
        price = numberFloat2Decimals(price);

        const priceText: string = price.toString();
        const hasDecimals: boolean = priceText.includes('.');
        const hasPriceOnlyOneDecimal: boolean = priceText.split('.')[1]?.length === 1;
        let formattedPrice: string = '';

        if (needCentsFormatting) {
            formattedPrice +=
                priceText === '0' || !hasDecimals
                    ? priceText + ',00 €'
                    : priceText.replace('.', ',') + (hasPriceOnlyOneDecimal ? '0 €' : ' €');
        } else {
            formattedPrice += priceText + ' €';
        }

        return formattedPrice;
    }
}
